import { ApiClient, ZatcaClient, useBaseModal } from "services";
import { useMemo, useEffect, useState } from "react";
import { ErrorDetailsComponent } from "components/common/ErrorDetailsComponent";
import { NotificationManager } from "react-notifications";
import { Col, Row, Alert } from "reactstrap";
import { FormGroup, } from "components/common";
import { Trans } from "react-i18next";
import Select from "react-select";
import { fetchZatcaApps, PrepareZeroTaxLines } from './constants'
import ExemptionModal from "./ExemptionModal";
import useModal from "hooks/useModal";
import { useHistory, useLocation } from "react-router-dom";
import { useOrganisationContext } from "hooks";

const useNoTaxHandler = (t, title, reloadHandler) => {

    const [isSending, setIsSending] = useState(false);
    const [details, setDetails] = useState(null);
    const [errorWindow, setErrorWindow] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const { selectedOrganisation } = useOrganisationContext();


    const [SetZatcaAppModal, ZatcaAppToggle, ZatcaAppModal] = useBaseModal()
    const { Modal: NoTaxModal, setIsOpen: setNoTaxModalOpen, isOpen: NoTaxModalOpen, toggle: noTaxModalToggle, ModalHeader: NoTaxModalHeader, ModalBody: NoTaxModalBody } = useModal();

    const [action, setAction] = useState("")
    const [zatcaApps, setZatcaApps] = useState();
    const [localZatcaData, setLocalZatcaData] = useState({});
    const [document, setDocument] = useState({});
    const [zeroRateLines, setZeroRateLines] = useState([]);
    const id = document ? document.InvoiceID || document.CreditNoteID || document.PrepaymentID : ''

    const zatca = ZatcaClient()
    const client = ApiClient()
    const removeQueryParam = useRemoveQueryParam();

    function useRemoveQueryParam() {
        const history = useHistory();
        const location = useLocation();

        return (param) => {
            const searchParams = new URLSearchParams(location.search);
            searchParams.delete(param);

            history.replace({
                pathname: location.pathname,
                search: searchParams.toString(),
            });
        };
    }

    useEffect(async () => {
        if (document.hasZeroTax) {
            const _zeroRateLines = await PrepareZeroTaxLines(client, document)
            setZeroRateLines(_zeroRateLines)
        }
    }, [document?.Reference])

    async function updateReasons(values) {
        try {
            await client.patch(`xero_actions/${selectedOrganisation.id}/document_exempt_reason?InvoiceID=${id}`, { ...values}).get("data");
            NotificationManager.success(t("Updated successfully"))
            noTaxModalToggle();
            checkZatcaApps(localZatcaData);
        } catch (error) {
            NotificationManager.error(t("Failed to update"))
        }
    }

    useEffect(async () => {
        const _apps = await fetchZatcaApps(zatca)
        setZatcaApps(_apps)
    }, []);


    const handleClose = () => {
        setErrorWindow(false);
        setDetails(null);
    };


    const refreshData = () => {
        setRefreshFlag(prevFlag => !prevFlag);
    };

    const checkZatcaApps = (values, actionType = '') => {
        if (zatcaApps?.length > 1) {
            setNoTaxModalOpen(false)
            ZatcaAppToggle()
        } else {
            postProcess(values, "", actionType)
        }
    }

    const preGetInvoiceXML = (values,) => {
        preProcess(values, 'xml_download')
    }

    const preHandleSDKPost = (values,) => {
        preProcess(values, 'sdk_send')
    }

    const preProcess = async (values, actionType) => {
        setLocalZatcaData(values)
        setAction(actionType)

        const _zeroRateLines = await PrepareZeroTaxLines(client, document) //adjusted to handle auto_report
        setZeroRateLines(_zeroRateLines)

        if (_zeroRateLines?.length > 0) {
            noTaxModalToggle()
        } else {
            checkZatcaApps(values, actionType)
        }
    }

    const postProcess = (values, selectedZatcaApp, actionType = "") => {
        let _action = action || actionType
        if (_action === 'xml_download')
            getInvoiceXML(values, selectedZatcaApp)
        else
            handleSDKPost(values, selectedZatcaApp)
    }

    const getInvoiceXML = (values, selectedZatcaApp) => {
        title = values.InvoiceNumber || values.Reference
        setNoTaxModalOpen(false)
        setIsSending(true)
        zatca.post("sdk_send/get_invoice_xml", values, { params: { id: selectedZatcaApp } })
            .then(response => {
                const { base64_content } = response.data;
                const link = window.document.createElement('a');
                link.href = `data:application/octet-stream;base64,${base64_content}`;
                link.download = `${title}.xml`;

                window.document.body.appendChild(link);
                link.click();

                window.document.body.removeChild(link);
                NotificationManager.success(t("Successfully downloaded"));
                setIsSending(false)
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data) {
                    setDetails(error.response.data);
                    setErrorWindow(true);
                } else {
                    NotificationManager.error(t("Error occurred while downloading"));
                }
                setIsSending(false)
            });
    };

    const handleSDKPost = (values, selectedZatcaApp) => {
        setNoTaxModalOpen(false)
        setIsSending(true)
        zatca.post("sdk_send/invoice", values, { params: { id: selectedZatcaApp } })
            .then(response => {
                setIsSending(false)
                setDetails(response.data);
                refreshData();
                removeQueryParam("auto_report");
                setTimeout(() => {
                    setErrorWindow(true);
                }, 500);
            })
            .catch(error => {
                setIsSending(false)
                removeQueryParam("auto_report");
                if (error.response && error.response.data && error.response.data) {
                    setDetails(error.response.data);
                    setErrorWindow(true);
                    NotificationManager.error(t("There are a few missing details", "Error"));
                } else {
                    NotificationManager.error(t("Error occurred while saving"));
                }
            });
    };


    const NoTaxComponent = useMemo(() => {
        return ({ formattedType, invoiceSDKZatca, selectedZatcaApp, setSelectedZatcaApp }) => (
            <>
                <ZatcaAppModal title={t('ZATCA application selection')} action={t("Confirm")} HandleSubmit={() => { postProcess(invoiceSDKZatca, selectedZatcaApp); ZatcaAppToggle() }}>
                    <Alert color="warning">
                        <Trans>You have multiple zatca OnBoardings, Please select one</Trans>
                    </Alert>
                    <Row>
                        <Col className="col-12">
                            <FormGroup label={t("Select a ZATCA application") + " *"} >
                                <Select placeholder={`${t("Select a ZATCA application")}`} options={zatcaApps} value={selectedZatcaApp} onChange={(e) => { setSelectedZatcaApp(e?.value || "") }} Isclearable={false} />
                            </FormGroup>
                        </Col>
                    </Row>
                </ZatcaAppModal>

                {NoTaxModalOpen && (
                    <NoTaxModal size="lg">
                        <NoTaxModalHeader toggle={noTaxModalToggle} onClosed={() => { }}>
                            <Trans>Zero Rate Reasons</Trans>
                        </NoTaxModalHeader>
                        <NoTaxModalBody>
                            <ExemptionModal
                                toggle={noTaxModalToggle}
                                updateReasons={updateReasons}
                                t={t}
                                zeroRateLines={zeroRateLines}
                            >
                            </ExemptionModal>
                        </NoTaxModalBody>
                    </NoTaxModal>
                )}
                {errorWindow && <ErrorDetailsComponent show={errorWindow} handleClose={() => handleClose()} details={details} typeOfInv={formattedType} showWarnings={true} reload={reloadHandler} />}
            </>

        )
    }, [NoTaxModal, ZatcaAppModal, errorWindow, details, NoTaxModalOpen, zeroRateLines])

    return { preGetInvoiceXML, preHandleSDKPost, NoTaxComponent, isSending, refreshFlag, setDocument, zatcaApps}
}

export default useNoTaxHandler